import { IBaseNotification, TMNotificationType } from "../types";
import { AwardNotificationModel } from "./award-notification-model";
import { SubscriptionNotificationModel } from "./subscription-notification-model";

export class NotificationModelFactory {
  private constructor() {}

  static create(notification: IBaseNotification) {
    switch (notification.type) {
      case TMNotificationType.AWARD_INFO:
      case TMNotificationType.AWARD:
        return new AwardNotificationModel(notification);
      case TMNotificationType.SUBSCRIPTION:
        return new SubscriptionNotificationModel(notification);
      default:
        return null;
    }
  }
}
